/* eslint-disable eqeqeq */
import React from "react";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/styles";
import {
  Typography,
  Card,
  CardContent,
  List,
  ListItem,
  ListItemText,
  ListItemAvatar,
  CircularProgress,
} from "@material-ui/core";

const useStyles = () => ({
  card: {
    display: "flex",
    flexDirection: "column",
    boxShadow:
      "0 4px 4px 0 rgba(0, 0, 0, 0.2), 0 2px 15px 0 rgba(0, 0, 0, 0.19)",
    borderRadius: 10,

    //height: "100%",
  },
  title: {
    color: "#3f51b5",
    display: "flex",
    fontSize: 14,
    marginTop: 5,
    width: "80%",
    marginLeft: 5,
  },
  titleIcon: {
    marginRight: 20,
    fontSize: 28,
  },
  titleDivider: {
    width: "80%",
    backgroundColor: "#3f51b5",
    opacity: "0.5",
    marginLeft: 20,
    marginBottom: 10,
  },
  cardContent: {
    width: "95%",
    overflow: "auto",
  },
  listItem: {
    outline: "none",
    cursor: "pointer",
    padding: 1,
    paddingLeft: 2,
  },
  listItemQAFailed: {
    outline: "none",
    cursor: "pointer",
    padding: 1,
    paddingLeft: 2,
    backgroundColor: "#ffb4b0",
    color: "white",
  },
  listItemDisputed: {
    outline: "none",
    cursor: "pointer",
    padding: 1,
    paddingLeft: 2,
    // backgroundColor:"#fcae1e",
    // color:"white"
    backgroundColor: "#ffe0a8",
    color: "black",
  },
  statusLabel: {
    fontWeight: 600,
    marginRight: 7,
    fontSize: 14,
    width: "90%",
    overflowWrap: "break-word",
  },
  resize: {
    padding: 10,
  },
  circularProgressStyle: {
    marginTop: 10,
    display: "flex",
    justifyContent: "center",
  },
  primaryTextStyle: {
    fontSize: 15,
    overflowWrap: "break-word",
    width: "63%",
    color: "#787676",
  },
  secondaryTextStyle: {
    fontSize: 12,
    color: "#787676",
  },
  primaryQAorDisputedTextStyle: {
    fontSize: 15,
    overflowWrap: "break-word",
    width: "63%",
    color: "white",
  },
  secondaryQAorDisputedTextStyle: {
    fontSize: 12,
    color: "white",
  },

  filterBtn: {
    fontSize: 11,
    textTransform: "capitalize",
    marginLeft: 4,
    marginRight: 4,
  },
  filterBtnContainer: {
    display: "flex",
    marginBottom: 5,
    marginRight: 5,
    marginLeft: 5,
    width: "100%",
    // width: "max-content"
  },

  formControl: {
    margin: 15,
    minWidth: 250,
  },
  selectEmpty: {
    //marginTop: theme.spacing(2),
  },
});

class OrderTab extends React.Component {
  //textFieldRef = null;
  constructor(props) {
    super(props);
    this.state = {
      //cardHeight: // Adjust the offset value as needed
    };
  }
  componentDidUpdate() {
    window.addEventListener("resize", this.handleResize);
    if (this.props.values.filterStatus == 13) {
      setTimeout(() => {
        //this.textFieldRef.focus();
      }, 1000);
    }
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.handleResize);
  }

  handleResize = () => {
    // this.setState({
    //  // cardHeight: window.innerHeight - 10, // Adjust the offset value as needed
    // });
  };

  render() {
    const { classes } = this.props;
    const minHeightValue = (21.94 / 100) * window.innerWidth;
    return (
      <React.Fragment>
        <Card
          style={{
            minWidth: minHeightValue,
            minHeight: window.innerHeight - 120,
            maxHeight: window.innerHeight - 120,
          }}
          className={classes.card}
        >
          <CardContent className={classes.cardContent}>
            {this.props.values.ordersDataLoading ? (
              <div className={classes.circularProgressStyle}>
                <CircularProgress />
              </div>
            ) : (
              <List>
                {this.props.values.ordersData.map((card) => {
                  return (
                    <>
                      <ListItem
                        key={card.jobId}
                        className={
                          card.isQAFailed == 1
                            ? classes.listItemQAFailed
                            : card.isDisputed == 1
                            ? classes.listItemDisputed
                            : classes.listItem
                        }
                        onClick={() => this.props.getOrderId(card)}
                        selected={
                          this.props.values.selectedOrder.jobId === card.jobId
                        }
                        style={{
                          borderBottom:
                            card.isQAFailed == 1 || card.isDisputed == 1
                              ? "1px solid white"
                              : "1px solid rgb(241 234 234)",
                        }}
                      >
                        <ListItemAvatar
                          style={{ marginLeft: 10, marginRight: 10 }}
                        >
                          <div style={{ fontSize: 16, textAlign: "center" }}>
                            <img
                              alt="img"
                              style={{ height: 55, width: 55, borderRadius: 8 }}
                              src={`${process.env.REACT_APP_API_DOMAIN}/${process.env.REACT_APP_SUB_API_NAME}/albums/C01ImageView?fileName=${card.thumbnail}`}
                            />
                          </div>
                        </ListItemAvatar>
                        <ListItemText
                          disableTypography
                          primary={
                            <Typography className={classes.primaryTextStyle}>
                              {"O# "}
                              {card.orderId + " - J# " + card.jobId}
                            </Typography>
                          }
                          secondary={
                            <>
                              <Typography
                                className={classes.secondaryTextStyle}
                              >
                                {"Status : "}
                                {card.statusLabel}{" "}
                              </Typography>
                              <Typography
                                className={classes.secondaryTextStyle}
                              >
                                {" "}
                                {card.createdOn}{" "}
                              </Typography>
                            </>
                          }
                        />
                      </ListItem>
                    </>
                  );
                })}
              </List>
            )}
          </CardContent>
        </Card>
      </React.Fragment>
    );
  }
}

OrderTab.propTypes = {
  classes: PropTypes.object.isRequired,
  values: PropTypes.object,
  getOrderId: PropTypes.func,
  onHandleChange: PropTypes.func,
};

OrderTab.defaultProps = {
  values: {},
  getOrderId: (fn) => fn,
  onHandleChange: (fn) => fn,
};

export default withStyles(useStyles)(OrderTab);
